// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"56":"380e34f2","692":"4e9e72ae"}[chunkId] + ".chunk.css");